import getters from './getters'
import mutations from './mutations'

const state = {
  stores: [],
  searchTerm: '',
  showLoadedOnly: false,
  documentTypes: {
    'rashodnayanakladnaya': 'РН',
    'rashodnayanakladnaya_zakaz': 'РНЗ'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
